import script from "./SignUpView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpView.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpView.vue?vue&type=style&index=0&id=5cb5b6a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb5b6a5"]])

export default __exports__